import { on, createReducer } from '@ngrx/store';
import { mergePeriodCost } from '@zerops/models/transaction-debit';
import { zefResetState } from '@zerops/zef/core';
import {
  periodCostSuccess,
  trackTransactionDebitGroupItem,
  TransactionDebitBaseActionUnion,
  transactionDebitGroupPrefillData,
  transactionDebitGroupSuccess,
  transactionDebitGroupUpdate
} from './transaction-debit-base.action';
import {
  TransactionDebitBaseState,
  TransactionDebitGroupUpdateSuccessPayload
} from './transaction-debit-base.model';
import {
  getTransactionGroupRangeSubscriptionName,
  transformDebitGroupTransformByMetric
} from './transaction-debit-base.utils';
import { trackTimeSeriesSubscriptionItem } from '../shared';

const initialState = new TransactionDebitBaseState();

const actionReducer = createReducer(
  initialState,
  on(
    transactionDebitGroupPrefillData,
    (s, data): TransactionDebitBaseState => mergeDebitGroup(s, data)),
  on(
    transactionDebitGroupSuccess,
    (s, { data }): TransactionDebitBaseState => mergeDebitGroup(s, data)
  ),
  on(
    transactionDebitGroupUpdate,
    (s, props): TransactionDebitBaseState => mergeDebitGroup(s, props)
  ),
  on(
    trackTransactionDebitGroupItem,
    (s, props): TransactionDebitBaseState => ({
      ...s,
      trackedItems: trackTimeSeriesSubscriptionItem(
        s.trackedItems,
        props.data,
        (item: any) => getTransactionGroupRangeSubscriptionName(
          item.data?.groupBy,
          item.data?.groupRange?.timeGroupBy,
          item.data?.projectId,
          item.data?.serviceId,
          item.data?.groupRange?.key
        )
      ),
    })
  ),
  on(
    periodCostSuccess,
    (s, { data }): TransactionDebitBaseState => ({
      ...s,
      periodCosts: mergePeriodCost(
        data.client,
        data.project,
        data.stack
      )
    })
  ),
  on(zefResetState, () => initialState)
);

export function transactionDebitBaseReducer(
  state: TransactionDebitBaseState,
  action: TransactionDebitBaseActionUnion
) {
  return actionReducer(state, action);
}

function mergeDebitGroup(s: TransactionDebitBaseState, data: TransactionDebitGroupUpdateSuccessPayload) {
  return {
    ...s,
    data: transformDebitGroupTransformByMetric(data, s.data)
  };
}
